module.exports = __webpack_public_path__ + "static/media/NanumMyeongjo-ExtraBold.b986085d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumMyeongjo-ExtraBold.ttf
// module id = 3267
// module chunks = 71